import { Box } from '@material-ui/core';
import React from 'react';
import EntityListView from '../../../shared/components/dashboards/EntityListView';
import { LiveContainer } from '../../LiveContainer';

const EntityListDashboard = (props) => {
  return (
    <LiveContainer
      isActive={(to) => {
        return to === `/live/list/${props.entityListId}`;
      }}
    >
      <Box p={1}>
        <EntityListView {...props} />
      </Box>
    </LiveContainer>
  );
};

export default EntityListDashboard;
